const PRIORITIES = ['URGENT', 'HIGH', 'MEDIUM', 'LOW'];

const PRIORITY_COLORS = {
  URGENT: 'var(--pd-crimson)',
  HIGH: 'var(--pd-warning)',
  MEDIUM: 'var(--pd-focus)',
  LOW: 'var(--pd-subtle)',
};

/**
 * Title, description, business and priority — the identity of a task.
 */
export function TaskCoreFields({ form, setForm, businesses }) {
  return (
    <>
      <input data-testid="task-title-input" autoFocus value={form.title} onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))} placeholder="Task title" className="w-full text-2xl font-medium outline-none bg-transparent" style={{ color: 'var(--pd-text)', letterSpacing: '-0.04em' }} />
      <textarea data-testid="task-description-input" value={form.description} onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))} placeholder="Add description..." rows={3} className="w-full text-sm outline-none resize-none rounded-[18px] px-4 py-3" style={{ background: 'var(--pd-panel-solid)', border: '1px solid var(--pd-border)', color: 'var(--pd-muted)' }} />

      <div className="grid gap-4 md:grid-cols-2">
        <div>
          <label className="text-[10px] uppercase tracking-[0.08em] font-semibold block mb-1.5" style={{ color: 'var(--pd-subtle)' }}>Business</label>
          <select data-testid="task-business-select" value={form.businessId} onChange={(e) => setForm((prev) => ({ ...prev, businessId: e.target.value }))} className="w-full px-3 py-3 rounded-[16px] text-sm" style={{ border: '1px solid var(--pd-border)', background: 'var(--pd-panel-solid)' }}>
            <option value="">None</option>
            {businesses.map((business) => <option key={business.id} value={business.id}>{`${business.shortCode} - ${business.name}`}</option>)}
          </select>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.08em] font-semibold block mb-1.5" style={{ color: 'var(--pd-subtle)' }}>Priority</label>
          <div className="flex gap-1.5">
            {PRIORITIES.map((priority) => (
              <button key={priority} type="button" onClick={() => setForm((prev) => ({ ...prev, priority }))} className="flex-1 py-2.5 rounded-xl text-[10px] font-semibold transition-colors" style={{ background: form.priority === priority ? PRIORITY_COLORS[priority] : 'var(--pd-panel-2)', color: form.priority === priority ? 'white' : 'var(--pd-subtle)' }}>
                {priority.slice(0, 3)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
